module.exports = __webpack_public_path__ + "img/partido-popular-cristiano.6de69e4e.png";